export default {
  title: "Collaboratori",
  description: "Invita persone ad aiutarti con l'organizzazione del matrimonio",
  count: "{{count}} collaboratori",
  invite: "Invita collaboratore",
  rolesTitle: "Ruoli disponibili",
  roles: {
    admin: "Amministratore",
    editor: "Editore",
    viewer: "Visualizzatore"
  },
  roleDescriptions: {
    admin: "Può modificare tutto e gestire i collaboratori",
    editor: "Può modificare le sezioni selezionate",
    viewer: "Può solo visualizzare le sezioni selezionate"
  },
  inviteEmail: "Indirizzo email",
  placeholder: "Inserisci l'indirizzo email della persona da invitare",
  role: "Ruolo",
  accessToSections: "Accesso alle sezioni",
  resourceTypes: {
    tasks: "Attività",
    guests: "Ospiti",
    budget: "Budget",
    timeline: "Timeline"
  },
  inviteSuccess: "Invito inviato con successo",
  list: "Lista collaboratori",
  empty: "Nessun collaboratore al momento",
  accessTo: "Accesso a",
  lastActive: "Ultima attività",
  remove: "Rimuovi collaboratore",
  modifyAccess: "Modifica accesso",
  updateRoleError: "Errore durante l'aggiornamento del ruolo",
  inviteError: "Errore durante l'invio dell'invito",
  status: {
    pending: "In attesa",
    accepted: "Accettata",
    refused: "Rifiutata",
    expired: "Scaduta"
  },
  activeLinks: {
    title: "Link di condivisione attivi",
    description: "Gestisci i link permanenti che consentono un accesso semplificato.",
    copy: "Copia",
    revoke: "Revoca",
    linkCopied: "Link copiato!",
    revokeConfirm: "Sei sicuro di voler revocare questo link?",
    revokeSuccess: "Link revocato con successo",
    noActiveLinks: "Nessun link attivo",
    securityInfo: "Questi link consentono l'accesso senza un account. Condividili con cautela."
  }
};
